// Entrypoint APP
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import LRoot from './LRoot';

import MobileView from './components/library/custom/-APP_TARGET/MobileView';

const isMobile = (/Android|iPhone|iPad|Mobile|Windows Phone/i.test(navigator.userAgent));
const root = document.getElementById(`DJAPPMM`);
if (root) {
  // root.oncontextmenu = () => false; //  V1 - react-contextmenu "^2.14.0" - PWA requirement - Disable Default Browser Right-Click
  root.addEventListener("contextmenu", (e) => { //V2 - @radix-ui/react-context-menu
    if (!e.target.closest(".allow-menu")) {
      e.preventDefault()
    }
  })

  // Load custom config from each project and inject it to the global config
  let config = null;
  try { config = require('./config.json') } catch(e) {}

  ReactDOM.render(
    <React.StrictMode>
      {!isMobile
        ? <LRoot
          ref={instance => { window.DJAPPMM = instance; }}
          configuration={config}
          playerSrcHTML={root.getAttribute('playerSrcHTML')}
          playerSrcCss={root.getAttribute('playerSrcCss')}
          playerSrcJSCore={root.getAttribute('playerSrcJSCore')}
          playerSrcJSAPI={root.getAttribute('playerSrcJSAPI')}
          playerSrcJSBridge={root.getAttribute('playerSrcJSBridge')}
          playerSrcCssCustom={root.getAttribute('playerSrcCssCustom')}
          playerIDRef={root.getAttribute('playerIDRef')}
        />
        : <MobileView />
      }
    </React.StrictMode>
  , root);
}

serviceWorker.unregister();
